import type { IconSvgObject } from './types';

const Ppt01Icon: IconSvgObject = [
  ["path", { d: "M4 12.9976L4.01973 3.99536C4.02229 2.89174 4.91832 1.99877 6.02195 2L12.9958 2.00776L20 8.99481L19.9922 12.9976M13 2.49778V6.99778C13 8.10235 13.8954 8.99778 15 8.99778H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22V19M4 19V16H6C6.82843 16 7.5 16.6716 7.5 17.5C7.5 18.3284 6.82843 19 6 19H4ZM10 22V19M10 19V16H12C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19H10ZM16 16H18M18 16H20M18 16V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Ppt01Icon;
